import BarChart from "@icons/BarChart";
import Colors from "@src/constants/Colors";

import {
  CardButtonText,
  CardButtonWrapper,
  CustomCard,
  CustomCardHeader,
  CustomCardHeaderTitle,
} from "./style";

interface ParentCardPropsType {
  children?: React.ReactNode;
  title: string;
  hideViewAllButton?: boolean;
  handleViewAllButton?: () => void;
  hidePrimaryButton?: boolean;
  handlePrimaryButton?: () => void;
}

const ParentCard = (props: ParentCardPropsType) => {
  const {
    children,
    title,
    handleViewAllButton,
    hideViewAllButton,
    handlePrimaryButton,
    hidePrimaryButton = true,
  } = props;

  return (
    <CustomCard>
      <CustomCardHeader>
        <CustomCardHeaderTitle
          color={Colors.neutralblack}
          $hideViewAllButton={!!hideViewAllButton}
        >
          {title}
        </CustomCardHeaderTitle>
        {!hideViewAllButton && (
          <CardButtonWrapper
            style={{ backgroundColor: "transparent" }}
            disableTouchRipple
            onClick={handleViewAllButton}
          >
            <BarChart color={Colors.primary} />
            <CardButtonText leftMargin="13">View All Data</CardButtonText>
          </CardButtonWrapper>
        )}
        {!hidePrimaryButton && (
          <CardButtonWrapper
            style={{ backgroundColor: "transparent" }}
            disableTouchRipple
            onClick={handlePrimaryButton}
          >
            <CardButtonText leftMargin="13">Done</CardButtonText>
          </CardButtonWrapper>
        )}
      </CustomCardHeader>
      {children}
    </CustomCard>
  );
};

ParentCard.defaultProps = {
  children: undefined,
};

export default ParentCard;
